__turbopack_context__.v({
  "camera": "DiS-OG_camera",
  "captionText": "DiS-OG_captionText",
  "credit": "DiS-OG_credit",
  "imagePart": "DiS-OG_imagePart",
  "postImg": "DiS-OG_postImg",
});
